import { ProviderBuilder, EGenMode } from '@educraft/base';

export function registerGenMulti(builder: ProviderBuilder): void {}
